export const CELL_HEIGHT = 66;

export const CELL_WIDTH = 220;
